// extracted by mini-css-extract-plugin
export default {"mobileRegistrationMessage":"MobileRegistrationMessage--mobileRegistrationMessage--8H5CO"};